import { render, staticRenderFns } from "./EditFichaProvincia.vue?vue&type=template&id=0edc464c"
import script from "./EditFichaProvincia.vue?vue&type=script&lang=js"
export * from "./EditFichaProvincia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports